import {createSlice} from "@reduxjs/toolkit";
import {setTicketsPageFilter} from "./actions";
import {startOfDay} from "@ots-frontend/ots-data"

type TicketsPageState = {
    filter: {
        fromDttm: number,
        toDttm?: number
    }
}

const INITIAL_STATE: Readonly<TicketsPageState> = {
    filter: {
        fromDttm: startOfDay(new Date()).getTime()
    },
};

const ticketsPageSlice = createSlice({
    name: "ui/tickets-page",
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            setTicketsPageFilter,
            (state, {payload}) => {
                state.filter = payload
            }
        );
    }
});

export const ticketsPageReducer = ticketsPageSlice.reducer;
